export const PageTopBar = ({children, marginClass = 'my-3'}) => {
    return (
        <div className={`overflow-hidden bg-white flex flex-row justify-between items-center py-1 ${marginClass}`}>
            {
                Array.isArray(children) ?
                    children.map((child, index) => 
                        <div className="text-gray-600" key={index}>{child}</div>
                    )
                    :
                    <div className="text-gray-600">{children}</div>
            }
        </div>
    )
}